<template>
  <div class="main">
    <div 
      class="list tac" 
      :style="{color:item.textColor, borderColor:item.borderColor,backgroundColor:item.fillColor}" 
      v-for="(item,index) in dataInfo.singlePageOptionList" 
      :key="index"
    >
      <div @click="singlePageClick(item)">{{item.optionName}}</div>
    </div>
    <div class="content">{{dataInfo.pageTextContent}}</div>
  </div>
</template>

<script>
export default {
  props:{
    dataInfo: {
      type: Object,
      default:()=>{}
    },
  },
  methods: {
    async singlePageClick(item){
      const params = {
        optionName: item.optionName,
        optionCode: item.optionCode,
        qrCodeNo: this.dataInfo.qrCodeNo,
        actionNo: this.dataInfo.actionNo,
      }
      this.$emit('changeBtn',params)
    }
  }
}
</script>

<style lang="less" scoped>
.main{
  margin-top: 120px;
}
.list{
  margin: 10px 5%;
  padding: 10px;
  border-radius: 60px;
  border-width:1px;
  border-style:solid;
  height: 60px;

  line-height: 60px;
  margin-bottom: 30px;
  font-size: 32px;
}
.content{
  margin: 50px 20px 0 20px;
  text-align: center;
  word-break: break-all;
}
.flex{
  display: flex;
}
.tac{
  text-align: center;
}
</style>